export const BusinessErrorMessage = {
  //'400': '请求的操作没有权限！',
  '401': '请重新登录',//token 验证错误
};

export class BusinessError extends Error {
  constructor(message, code) {
    message = BusinessErrorMessage[code] ? BusinessErrorMessage[code] : message;
    super(message);
    this.stack = Error().stack;
    this.name = 'BusinessError';
    this.code = code;
    this.type = 'warning';
  }
  toErrorString() {
    return `${this.message}(${this.code})`;
  }
}

export const RequestErrorMessage = {
  '404': '请求的操作不存在！',
  '401': '授权过期或错误！'
};
export class RequestError extends Error {
  constructor(code, request) {
    let message = RequestErrorMessage[code] || '处理数据时发生意外错误，请联系管理员！';
    super(message);
    this.stack = Error().stack;
    this.code = code;
    this.type = 'error';
    this.action = 'request';
    this.name = 'RequestError';
    this.request = request;
  }
  toErrorString() {
    return `${this.message}(${this.action}:${this.code})[${this.request.config.url}]`;
  }
}

export function requestHandle() {
  return (ctx) => {
    console.log(ctx)
    const result = ctx.result;
    if (result.code === 401 || result.code === 404 || result.code === 422) window.location.href =
      `http://passport.infzm.com/login?version=${process.env.version}&&project=cms&&platform=${process.env.platform}&&refer=${encodeURIComponent(window.location.hash.slice(1))}`
    if (result.code < 200) throw new Error(result.msg);
    if (result.code === 200 || result.data instanceof Array) { // 200 or page list
      ctx.result = result.data;
      return Promise.resolve(ctx);
    } else {
      return Promise.reject(new BusinessError(result.msg, result.code)); // 返回业务出错时
    }
  }
};

export const getBaseFontSize = (screenWidth = window.innerWidth) => (screenWidth >= 786 ? 37.5 : parseStyleVal(window.getComputedStyle(document.documentElement)["fontSize"]));
export const toVW = val => val / (750 / 100)
export const toRem = val => (val / getBaseFontSize() / 2)
export const styleValRegExp = /(\%|em|px|vh|vw)$/
export const parseStyleVal = val => val.replace(styleValRegExp, '')
export const getClientRect = ($el)=>{
  let clientRect
  try{
    clientRect = $el.getBoundingClientRect()
  }catch(e){
    clientRect = null
  }
  return clientRect
}

export const script = url => {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.type = `text/javascript`;
    //Firefoox, Opera, Chrome, Safari 3+
    script.onload = () => {
      //alert('Script loaded!')
      resolve('Script loaded!')
    };
    script.src = `${url}`;
    try {
      document.getElementsByTagName('body')[0].appendChild(script)
    } catch (err) {
      reject(err)
    }

  })
}
export const isWeiXin = () => {
  var ua = navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) == "micromessenger";

}

export const isWeiBo = () => {
  var ua = navigator.userAgent.toLowerCase();
  return ua.match(/WeiBo/i) == "weibo";

}

export const isQQ = () => {
  var ua = navigator.userAgent.toLowerCase();
  return ua.match(/QQ/i) == "qq";

}

export const isApp = () => {
  return typeof window.JSBinder != 'undefined';
}

export async function existJSBinder() {
  let temp;
  let loopTimes = 0;
  const LOOP_MAX_TIMES = 3;
  const LOOP_CYCLE_TIME = 50
  return await new Promise((resolve, reject) => {
    let loopNumber = setInterval(function () {
      if(loopTimes >= LOOP_MAX_TIMES) {
        clearInterval(loopNumber)
        resolve(!!temp)
      } else {
        loopTimes += 1
      }
      try {
        if ((typeof JSBinder) != "undefined") {
          temp = JSBinder
          clearInterval(loopNumber)
          resolve(!!temp)
        } else {
          console.log('without JSBinder!!!')
        }
      } catch (err) {
        console.log(err)
      }
    }, LOOP_CYCLE_TIME);
  })
}

export const isPC = () => {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod", "MiuiBrowser", "MeeGo", "BlackBerry", "iPad"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  if (!!userAgentInfo.match(/AppleWebKit.*Mobile.*/)) flag = false;
  return flag;
}



export const secToHHMMSS = (seconds) => {
  if(Number(seconds) < 0) return ''
  var msec = seconds;
  var dd = Math.floor(msec / 1000 / 60 / 60 /24);
  msec -= dd * 1000 * 60 * 60 * 24;
  var hh = Math.floor(msec / 1000 / 60 / 60);
  msec -= hh * 1000 * 60 * 60;
  var mm = Math.floor(msec / 1000 / 60);
  msec -= mm * 1000 * 60;
  var ss = Math.floor(msec / 1000);
  msec -= ss * 1000
  return `${dd ? dd +'天' : '' }${hh ? hh +'小时' : '' }${mm ? mm +'分钟' : '' }`
}
